import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Heading, SvgIcon, TextLink, Text } from "@cinch-labs/design-system";
import styles from "./get-in-touch.module.css";
const GetInTouch = ()=>/*#__PURE__*/ _jsxs("section", {
        className: styles.container,
        children: [
            /*#__PURE__*/ _jsx(Heading, {
                className: styles.title,
                children: "Need to get in touch?"
            }),
            /*#__PURE__*/ _jsx(Text, {
                className: styles.body,
                children: "Call, email or WhatsApp, we’re here to help."
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: styles.cardGroup,
                children: [
                    /*#__PURE__*/ _jsxs("div", {
                        className: styles.card,
                        children: [
                            /*#__PURE__*/ _jsx(SvgIcon, {
                                name: "mail"
                            }),
                            /*#__PURE__*/ _jsx(Heading, {
                                element: "h3",
                                className: styles.cardHeading,
                                children: "Customer Support"
                            }),
                            /*#__PURE__*/ _jsx(TextLink, {
                                href: "mailto:hello@cinch.co.uk",
                                target: "_blank",
                                rel: "noreferrer",
                                hasNoLine: true,
                                children: "hello@cinch.co.uk"
                            }),
                            /*#__PURE__*/ _jsx(TextLink, {
                                href: "tel:+443330154101",
                                target: "_blank",
                                rel: "noreferrer",
                                hasNoLine: true,
                                children: "0333 015 4101"
                            }),
                            /*#__PURE__*/ _jsx(TextLink, {
                                href: "https://wa.me/447831910589",
                                target: "_blank",
                                rel: "noreferrer",
                                hasNoLine: true,
                                children: "WhatsApp"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: styles.card,
                        children: [
                            /*#__PURE__*/ _jsx(SvgIcon, {
                                name: "edit"
                            }),
                            /*#__PURE__*/ _jsx(Heading, {
                                element: "h3",
                                className: styles.cardHeading,
                                children: "Write to us"
                            }),
                            /*#__PURE__*/ _jsxs(Text, {
                                children: [
                                    "Cinch Cars Limited",
                                    /*#__PURE__*/ _jsx("br", {}),
                                    " Form 2, 18 Bartley Wood",
                                    /*#__PURE__*/ _jsx("br", {}),
                                    " Business Park, Bartley Way,",
                                    /*#__PURE__*/ _jsx("br", {}),
                                    " Hook, Hampshire RG27 9XA"
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
export default GetInTouch;
